import * as Sentry from '@sentry/react'

/**
 * Tarayıcı tarafı hata takibi — YES-91.
 *
 * DSN tanımlı değilse hiç kurulmaz: geliştirmede ve testte sessiz kalır.
 *
 * Kişisel veri gönderilmiyor. Tarayıcıda asıl risk sunucudakinden farklı:
 * kullanıcının doldurduğu form alanları (`sendDefaultPii` kapalı) ve ekranda
 * yazan üye bilgileri (oturum kaydı/replay hiç açılmadı).
 */
const DSN = import.meta.env.VITE_SENTRY_DSN

export function configureSentry(): boolean {
  if (!DSN) return false

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    // Hangi sürümün hata verdiği, hatanın kendisi kadar önemli (YES-90).
    release: __APP_VERSION__,
    sendDefaultPii: false,
    tracesSampleRate: 0.1,
    beforeSend(event) {
      // İstek gövdeleri ve çerezler asla gitmesin — sunucu tarafındaki
      // kuralın aynısı.
      if (event.request) {
        delete event.request.data
        delete event.request.cookies
      }
      return event
    },
  })
  return true
}
